import LayoutTabs, {
  DraggableTabsProps
} from "@/components/controls/LayoutTabs";
import Section, {
  SectionProps,
  processSubtitleWithBreak
} from "@/pages/settings/components/sections/Section";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import Text from "@/components/ui/text";
import React, { ReactNode } from "react";

interface PageLayoutProps {
  title: string;
  subTitle?: string;
  logoIcon?: ReactNode;
  action?: ReactNode;
  tabs?: DraggableTabsProps;
  sections?: SectionProps[];
  children?: ReactNode;
  "data-test"?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  subTitle,
  action,
  sections,
  logoIcon,
  tabs,
  children,
  "data-test": dataTest
}) => {
  return (
    <div
      className="w-full flex items-center justify-center mb-4"
      data-test={dataTest}
    >
      <div className="pt-12 flex flex-col items-start justify-start w-[800px] gap-12">
        <div className="flex w-full flex-row justify-between items-center">
          <div className="flex w-full flex-row items-center gap-6">
            {logoIcon && (
              <LogoIconContainer
                icon={logoIcon}
                index={-1}
                className="w-12 h-12 rounded-2xl"
                innerClassName="rounded-2xl"
              />
            )}
            <div className="flex w-full flex-col justify-start ">
              <div className="flex flex-row justify-between items-center">
                <Text variant="title3H1">{title}</Text>
                {action}
              </div>
              {subTitle && (
                <Text variant="bodySecondary" className="whitespace-pre-line">
                  {processSubtitleWithBreak(subTitle)}
                </Text>
              )}
            </div>
          </div>
        </div>
        {(children || tabs) && (
          <div className="flex flex-col items-start justify-start w-full gap-8">
            <div className="w-full">{tabs && <LayoutTabs {...tabs} />}</div>
            {children}
          </div>
        )}
        {sections &&
          sections.map((section, index) => (
            <Section key={index} {...section} />
          ))}
      </div>
    </div>
  );
};

export default PageLayout;
